export default {
    GET_All: "[zina_flow][cpo] Get all cpos",
    GET_All_SUCCESS: "[zina_flow][cpo] Get all cpos success",
    GET_All_FAIL: "[zina_flow][cpo] Get all cpos fail",

    CHANGE_PAGE: "[zina_flow][cpo] Change page",
    FILTER_LIST: "[zina_flow][cpo] Filter change",
    UPDATE_PAGINATION: "[zina_flow][cpo] Update pagination",

    GET_CPO_ITEMS: "[zina_flow][cpo] Get cpo items",
    GET_CPO_ITEMS_SUCCESS: "[zina_flow][cpo] Get cpo items success",
    GET_CPO_ITEMS_FAIL: "[zina_flow][cpo] Get cpo items fail",

    GET_CPO_ITEM: "[zina_flow][cpo] Get cpo item",
    GET_CPO_ITEM_SUCCESS: "[zina_flow][cpo] Get cpo item success",
    GET_CPO_ITEM_FAIL: "[zina_flow][cpo] Get cpo item fail",

    GET_CPO_ITEM_COMMENTS: "[zina_flow][cpo] Get cpo item comments",
    GET_CPO_ITEM_COMMENTS_SUCCESS: "[zina_flow][cpo] Get cpo item comments success",
    GET_CPO_ITEM_COMMENTS_FAIL: "[zina_flow][cpo] Get cpo item comments fail",

    NEW_CPO_ITEM_COMMENT: "[zina_flow][cpo] new cpo item comment",
    NEW_CPO_ITEM_COMMENT_SUCCESS: "[zina_flow][cpo] new cpo item comment success",
    NEW_CPO_ITEM_COMMENT_FAIL: "[zina_flow][cpo] new cpo item comment fail",

    GET_CPO_HISTORY: "[zina_flow][cpo] Get cpo history",
    GET_CPO_HISTORY_SUCCESS: "[zina_flow][cpo] Get cpo history success",
    GET_CPO_HISTORY_FAIL: "[zina_flow][cpo] Get cpo history fail",

    CANCEL_CPO_ITEM: "[zina_flow][cpo] Cancel cpo item",
    CANCEL_CPO_ITEM_SUCCESS: "[zina_flow][cpo] Cancel cpo item success",
    CANCEL_CPO_ITEM_FAIL: "[zina_flow][cpo] Cancel cpo item fail",

    CANCEL_CPO: "[zina_flow][cpo] Cancel CPO",
    CANCEL_CPO_SUCCESS: "[zina_flow][cpo] CPO Cancelled successfully",
    CANCEL_CPO_FAIL: "[zina_flow][cpo] CPO cancel failed",

    REPORT_START: "[zina_flow][cpo] Send report information",
    REPORT_SUCCESS: "[zina_flow][cpo] Send report sucessfull",
    REPORT_ERROR: "[zina_flow][cpo] Send report error",
    REPORT_CLEAN: "[zina_flow][cpo] Clean report messages",

    NON_OET_RELATED_CPO: "[zina_flow][cpo] markek cpo non oet related",
    NON_OET_RELATED_CPO_SUCCESS: "[zina_flow][cpo] markek cpo non oet related success",
    NON_OET_RELATED_CPO_FAIL: "[zina_flow][cpo] markek cpo non oet related fail",

    UPDATE_CPO: "[zina_flow][cpo] update cpo",
    UPDATE_CPO_SUCCESS: "[zina_flow][cpo] update cpo sucessfull",
    UPDATE_CPO_FAIL: "[zina_flow][cpo] update cpo fail",

    LIST_CIRCLES: "[zina_flow][cpo] list circles",
    LIST_CIRCLES_SUCCESS: "[zina_flow][cpo] list circles success",
    LIST_CIRCLES_FAIL: "[zina_flow][cpo] list circles fail",

    SEND_FILE: "[zina_flow][cpo] send file",
    SEND_FILE_SUCCESS:"[zina_flow][cpo] send file success",
    SEND_FILE_FAIL:"[zina_flow][cpo] send file fail",
    
    RE_OPEN_CPO: "[zina_flow][cpo] re-open-cpo",
    RE_OPEN_CPO_END: "[zina_flow][cpo] re-open-cpo-end"
};
